import type { Product, ProductVariant } from '~/types/models/product'

export function getDefaultVariant(product: Product) {
  const available: ProductVariant[] = product.variants.filter(
    product => product.stockStatus !== 'no-stock',
  )
  return available[0]! || product.variants[0]!
}
